import { selectRetailer } from '../../actions/subordinate-list.actions';
import template from './rw-subordinates-dropdown.html';

const mapDispatchToThis = {
  selectRetailer,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state')
class RwSubordinatesDropdownController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(null, mapDispatchToThis)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class RwSubordinatesDropdownComponent {
  constructor() {
    this.controller = RwSubordinatesDropdownController;
    this.template = template;
    this.bindings = {
      locations: '<',
    };
    this.transclude = {
      trigger: 'rwSubordinateDropdownTrigger',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-subordinates/components/rw-subordinates-dropdown/rw-subordinates-dropdown-component.js